import React, { useState, useContext } from 'react';
import useSWR from 'swr';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Zoom,
  IconButton,
  CircularProgress
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Snackbar } from 'Components';
import { AppContext } from 'Context';
import { dataFetcher, endpoints } from 'Api';
import { Input } from '../Input';
import styles from './NameEditModal.module.css';

const defaultSnackbar = { isVisible: false, type: undefined, message: undefined };

const NameEditModal = ({ isVisible, onHide: onClose, title, firstNameLabel, lastNameLabel }) => {
  const { userDetails, setUserDetails, langText } = useContext(AppContext);
  const commonText = langText?.common;
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');

  const [snackbar, setSnackbar] = useState(defaultSnackbar);

  const onHide = () => {
    setFirstname('');
    setLastname('');
    setSnackbar(defaultSnackbar);
    onClose();
  };

  const { isValidating: updatingName, mutate: updateName } = useSWR([endpoints.updateMyProfile, firstname, lastname], {
    fetcher: (url, inputFirstname, inputLastname) => dataFetcher(url, { firstname: inputFirstname, lastname: inputLastname }),
    onSuccess: ({ success }) => {
      if (success) {
        setSnackbar({ isVisible: true, type: 'success', message: 'Name was updated successfully' });
        setUserDetails({ ...userDetails, firstname, lastname });
        onClose();
        setTimeout(() => {
          setFirstname('');
          setLastname('');
          setSnackbar(defaultSnackbar);
        }, 300);
      } else {
        setSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong while updating name' });
      }
    },
    onError: () => {
      setSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong while updating name' });
    },
  });

  return (
    <>
      <Dialog
        open={isVisible}
        onClose={onHide}
        TransitionComponent={Zoom}
        maxWidth="xs"
        fullWidth
        classes={{ paper: styles.dialogPaper }}
      >
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{title}</h2>
          <IconButton onClick={onHide} className={styles.closeButton}>
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent className={styles.modalContent}>
          <div className={styles.formGroup}>
            <label className={styles.label}>{firstNameLabel}</label>
            <Input
              noLable
              className={styles.inputField}
              containerClassName={styles.inputFieldContainer}
              onInput={(e) => {
                const { target: { value: inputFirstname } } = e;
                setFirstname(inputFirstname);
              }}
              type="code"
              placeholder={userDetails?.firstname}
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>{lastNameLabel}</label>
            <Input
              noLable
              className={styles.inputField}
              containerClassName={styles.inputFieldContainer}
              onInput={(e) => {
                const { target: { value: inputLastname } } = e;
                setLastname(inputLastname);
              }}
              type="code"
              placeholder={userDetails?.lastname}
            />
          </div>
        </DialogContent>

        <DialogActions className={styles.modalActions}>
          <button
            className={styles.cancelButton}
            onClick={onHide}
            disabled={updatingName}
          >
            {commonText?.cancel || 'Cancel'}
          </button>
          <button
            className={styles.updateButton}
            onClick={updateName}
            disabled={!(firstname || lastname) || updatingName}
          >
            {updatingName ? (
              <>
                <CircularProgress size={16} className={styles.buttonLoader} />
                {commonText?.updating || 'Updating'}
...
              </>
            ) : (
              commonText?.update || 'Update'
            )}
          </button>
        </DialogActions>
      </Dialog>

      <Snackbar
        isVisible={snackbar?.isVisible}
        message={snackbar?.message || ''}
        onClose={() => { setSnackbar(defaultSnackbar); }}
        type={snackbar?.type}
      />
    </>
  );
};
export default NameEditModal;
